import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/shadcn/dialog'
import { COMPONENT_HEADER_HEIGHT } from '../../config'

export const ChartDialog = ({
  trigger,
  title,
  description,
  tilefilters,
  children,
}: {
  trigger: React.ReactNode
  title?: string
  description?: string
  tilefilters?: React.ReactNode
  children: React.ReactNode
}) => {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="z-[1001] max-h-[calc(100vh-40px)] max-w-[calc(100vw-40px)] bg-background">
        {(title || description) && (
          <DialogHeader style={{ height: COMPONENT_HEADER_HEIGHT }}>
            <div className="flex items-end justify-between gap-2 pt-3">
              <div>
                {title && <DialogTitle className="text-lg font-normal">{title}</DialogTitle>}
                {description && <DialogDescription>{description}</DialogDescription>}
              </div>
              {tilefilters}
            </div>
          </DialogHeader>
        )}
        {children}
      </DialogContent>
    </Dialog>
  )
}
